module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_identity.js
// module id = 1144
// module chunks = 0